export const INCLUDED_FEATURES = [
  'Unlimited daily check-ins',
  'AI companion (Mia) — chat anytime',
  'Pattern insights and mood charts',
  'Guided journaling with AI prompts',
  '100+ evidence-based coping skills',
  'Coping Skills Bingo',
  'Achievements, badges, and streaks',
  'Data export and privacy controls',
  'All future updates included',
];

